import React from "react";
import classNames from "classnames";

import CreatorPlaceholder from "src/images/creator-placeholder.svg";
import { GlobalTaskSearchResult } from "src/types";
import CustomImage from "src/app/components/CustomImage/CustomImage";

interface Props {
  data: GlobalTaskSearchResult;
}

export function GlobalTaskCover(props: Props) {
  return (
    <CustomImage
      className={classNames("search-section__item-cover")}
      src={props?.data?.avatarUrl ?? CreatorPlaceholder}
      alt="campaign-icon"
      fallbackImageSrc={CreatorPlaceholder}
      loading="lazy"
    />
  );
}
